
import "./styles.css";
import MyRoutes from "./routers/routes";

export default function App() {
  return (
    <div className="App">
  
      <MyRoutes />
    </div>
  );
}
